import http from './http'
import axios from 'axios'

const PREURL = '/pgc/activity/number/get/'

// 获取用户唯一编号
export const $getUniqueNo = (params: any) => {
  return http.get(`${PREURL}uniqueNo`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

//用户是否领取过号码牌
export const $getHasNo = (params: any) => {
  return http.get(`${PREURL}hasNo`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

// 下载pag文件
export const $fetchPag = (url: string) => {
  return axios.get(url, {
    responseType: 'arraybuffer',
  })
}
